import { useMutation } from 'react-query';
import untieTenantFromRoom from '../requests/untieTenantFromRoom';

const useUntieTenantFromRoom = (options) =>
  useMutation(({ values }) => untieTenantFromRoom(values), options);

export default useUntieTenantFromRoom;
